<div mat-dialog-title>
    Items in Cart
    <div class="pull-right close" (click)="close()"> &#10005; </div>
</div>
<div mat-dialog-content>
    <div class="clearfix"></div>
    <div>
        <p>Your cart contains items from {{ preSelectedBrand }}. Would you like to reset your cart before proceeding with {{ currentItemBrand }}?</p>
    </div>
    <div class="clearfix"></div>
    <div class="space-20"></div>
    <div class="clearfix"></div>
</div>
<div mat-dialog-actions style="float: right;">
    <button btn-border (click)="close()" style="margin-right: 10px;">
        NO
    </button>
    <button btn-primary (click)="resetCart()">
        YES
    </button>
</div>